import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import SearchInput from "@insite/content-library/Widgets/Header/SearchInput";
import React from "react";

interface OwnProps extends WidgetProps {
}

export const HeaderSearchInput: React.FC<OwnProps & { isAnimated?: boolean }> = ({
    id,
}) => {

    return (
        <div  className="as-serach-form">
            <div className="as-header-form-group">
                <SearchInput id={id}/>
            </div>
        </div>

    );
};

const widgetModule: WidgetModule = {
    component: HeaderSearchInput,
    definition: {
        group: "Header",
        displayName: "Search Input",
        allowedContexts: ["Header"],
    },
};

export default widgetModule;
